import { Component, OnInit, Inject } from '@angular/core'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { Group } from '../interfaces'

export interface GroupSharingDialogData {
  group: Group
}

@Component({
  selector: 'app-groups-dialog-sharing',
  templateUrl: './groups-dialog-sharing.component.html',
  styleUrls: ['./groups-dialog-sharing.component.scss'],
})
export class GroupsDialogSharingComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<GroupsDialogSharingComponent>,
    @Inject(MAT_DIALOG_DATA) public data: GroupSharingDialogData
  ) {}

  ngOnInit(): void {}

  closeDialog() {
    this.dialogRef.close()
  }
}
